import { Stack, Text, Flex } from "@mantine/core";
import { useTranslation } from "react-i18next";

import { CalculatorInput, SectionText } from "components";

interface ICalculatorInstallment {
  form: any;
  inputVariant?: string;
  labelVariant?: string;
}

const CalculatorInstallment = ({
  form,
  inputVariant,
  labelVariant,
}: ICalculatorInstallment) => {
  const { t } = useTranslation();

  return (
    <Stack mb={20}>
      <SectionText
        text={t("input.monthlyInstallment.label")}
        variant={labelVariant}
      />
      <Flex justify="space-around" align="center">
        <SectionText
          text={t("input.monthlyInstallmentFrom.label")}
          variant={labelVariant}
        />
        <CalculatorInput
          rightSection={<Text size={"sm"}>{t("currency.switzerland")}</Text>}
          rightSectionWidth={40}
          variant={inputVariant}
          key={form.key("monthlyInstallmentFrom")}
          {...form.getInputProps("monthlyInstallmentFrom")}
          label={t("input.monthlyInstallment.label")}
          disabled={true}
        />
        <SectionText
          text={t("input.monthlyInstallmentTo.label")}
          variant={labelVariant}
        />
        <CalculatorInput
          rightSection={<Text size={"sm"}>{t("currency.switzerland")}</Text>}
          rightSectionWidth={40}
          variant={inputVariant}
          key={form.key("monthlyInstallmentTo")}
          {...form.getInputProps("monthlyInstallmentTo")}
          label={t("input.monthlyInstallment.label")}
          disabled={true}
        />
      </Flex>
    </Stack>
  );
};

export default CalculatorInstallment;
